import React from 'react';
import classnames from 'classnames';
import s from './UserSymbol.scss';
export var UserSymbol = function (_a) {
    var userType = _a.userType, className = _a.className;
    return React.createElement("span", { className: classnames(s['symbol'], s[userType], className) });
};
UserSymbol.displayName = 'UserSymbol';
export default UserSymbol;
//# sourceMappingURL=UserSymbol.js.map